import React from 'react';
import Button from '../ui/Button';

const Pricing = () => {
  return (
    <section className="py-24 bg-slate-900">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-slate-100 mb-4">Choose How You Learn</h2>
          <p className="text-slate-400">Start small or unlock full access.</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {/* Card 1 */}
          <div className="bg-slate-950 p-8 rounded-2xl border border-slate-800 flex flex-col">
            <h3 className="text-xl font-bold text-slate-100 mb-2">Starter Course</h3>
            <p className="text-slate-500 text-sm mb-6">Ideal to try LearnAnimated.</p>
            <ul className="space-y-3 mb-8 flex-1 text-slate-400 text-sm">
              <li>• One subject of choice</li>
              <li>• One class range</li>
              <li>• Unlimited replays</li>
            </ul>
            <Button variant="secondary" className="w-full">View Details</Button>
          </div>

          {/* Card 2 - Highlighted */}
          <div className="bg-slate-800 p-8 rounded-2xl border border-cyan-500/30 flex flex-col relative transform md:-translate-y-4 shadow-xl shadow-cyan-900/20">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-cyan-500 text-slate-950 text-xs font-bold px-3 py-1 rounded-full">
              MOST POPULAR
            </div>
            <h3 className="text-xl font-bold text-slate-100 mb-2">Full Portal Access</h3>
            <p className="text-slate-400 text-sm mb-6">Best for long-term learning.</p>
            <ul className="space-y-3 mb-8 flex-1 text-slate-300 text-sm">
              <li>• All Subjects (Sci, Math, AI)</li>
              <li>• Classes 5-12 Access</li>
              <li>• AI Lab Projects</li>
              <li>• Progress Certificates</li>
            </ul>
            <Button variant="primary" className="w-full">Get Full Access</Button>
          </div>

          {/* Card 3 */}
          <div className="bg-slate-950 p-8 rounded-2xl border border-slate-800 flex flex-col">
            <h3 className="text-xl font-bold text-slate-100 mb-2">School Plans</h3>
            <p className="text-slate-500 text-sm mb-6">For institutions.</p>
            <ul className="space-y-3 mb-8 flex-1 text-slate-400 text-sm">
              <li>• Bulk student accounts</li>
              <li>• Teacher dashboard</li>
              <li>• Custom curriculum mapping</li>
            </ul>
            <Button variant="secondary" className="w-full">Talk to Us</Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;